// extracted by mini-css-extract-plugin
export default {"pricing":"mAZF70It--PricingMarketingHook_pricing__6j3zW"};